import { axiosInstance as axios } from "@/utils/wd_axios.js";
import { userKeys, wdConfigData } from "@/service/wd_app_config.js";

/// POST https://{your-resource-name}.openai.azure.com/openai/deployments/{deployment-id}/chat/completions?api-version={api-version}
// azure open API
export const az_ppt_completion = (params) => {
  var requestBody = {
    taskType: params.taskType,
    inputText: params.inputText,
  };
  var accessToken = localStorage.getItem(userKeys.key_corporationAccessToken);
  // var url = "/api/copilotTaskEntire/completionPPT";
  var url = `${wdConfigData.baseURLApi}/ppt/completion`;
  return axios.post(url, requestBody, {
    headers: {
      AccessToken: accessToken,
      "Content-Type": "application/json",
    },
  });
};

export const az_genereate_imageUrl = (params) => {
  var requestBody = {
    inputText: params.inputText,
    taskType: params.taskType,
  };
  // var url = "/api/copilotTaskImage/generateOneImageUrl";
  var url = `${wdConfigData.baseURLApi}/ppt/completionImageUrl`;
  var accessToken = localStorage.getItem(userKeys.key_corporationAccessToken)
  return axios.post(url, requestBody, {
    headers: {
      AccessToken: accessToken,
      "Content-Type": "application/json",
    },
  });
};

export const az_optimize_content = (params) => {
  var requestBody = {
    taskType: params.taskType,
    sourceText: params.sourceText,
    inputText: params.inputText,
  };
  // var url = "/api/copilotTaskPartial/optimizeSlide";
  var url = `${wdConfigData.baseURLApi}/ppt/optimizeContent`;
  return axios.post(url, requestBody, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const az_generate_onepage = (params) => {
  var requestBody = {
    taskType: params.taskType,
    sourceText: params.sourceText,
    inputText: params.inputText,
  };
  var url = `${wdConfigData.baseURLApi}/ppt/completionOnePage`;
  return axios.post(url, requestBody, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

// 以下在合并后不再使用
export const az_generate_image = (params) => {
  var requestBody = {
    inputText: params.inputText,
    taskType: params.taskType,
  };
  var url = "/api/copilotTaskImage/generateOneImage";
  return axios.post(url, requestBody);
};

export const az_download_image = (params) => {
  var requestBody = {
    imageUrl: params.imageUrl,
    width: params.width,
    height: params.height,
    radiusType: params.radiusType, // 0-直角；1-圆角；2-圆
    scaleType: 10, // 0-default; 传10
    cropLocationAlign: 32, // 1-左上，2-上中，4-右上，16-左中, 32-从中心开始取， 64-右中， 256-左下，512-中下，1024-右下
  };
  var url = "/api/copilotTaskImage/saveImage";
  return axios.post(url, requestBody);
};

export const az_genereate_iconUrl = (params) => {
  let accessToken = localStorage.getItem(userKeys.key_accessToken);
  var requestBody = {
    inputText: params.inputText,
  };
  var url = "/api/copilotTaskImage/generateOneIconUrl";
  return axios.post(url, requestBody, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};
